export default __webpack_public_path__ + "static/media/chat_bot_image7.e173bc12.jpg";